import { useUserStore } from '@/entities/user/index';

export default defineNuxtRouteMiddleware(() => {
  const userStore = useUserStore();
  const isAuth = userStore.isAuth;

  if (!isAuth) {
    return navigateTo('/');
  }
});
